import React, { Fragment } from 'react';
import { useStore } from 'modules/Stores';
import { observer } from 'mobx-react';
// components
import { useThemeDetector } from '@upstox/upstox-ui';
import { ChangeThemeModal } from '../ChangeThemeModal/ChangeThemeModal';

const themes: ThemeKeys[] = ['auto', 'light', 'dark'];

const ChangeThemeModalContainer = () => {
  const {
    theme,
    setTheme,
    toggleModal,
    modalsConfig: { changeTheme },
  } = useStore('AppStore');

  const autoTheme = useThemeDetector();

  const handleSaveTheme = (selectedTheme: ThemeKeys) => {
    const currentTheme = theme === 'auto' ? autoTheme : theme;
    setTheme(selectedTheme, currentTheme);
  };

 return changeTheme
  ? (
    <ChangeThemeModal
      onClose={() => toggleModal('changeTheme')}
      handleSaveTheme={handleSaveTheme}
      themeOptions={themes}
      defaultValue={theme}
    />
  )
  : <Fragment />;
};

export default observer(ChangeThemeModalContainer);
